"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const form_1 = require("../form");
const navigation_1 = require("../navigation");
const styled_1 = require("../styled");
const editable_context_1 = require("./editable-context");
const lodash_1 = require("lodash");
const Tag = require("@atlaskit/tag").default;
const TagGroup = require("@atlaskit/tag-group").default;
function withEditableField(Component) {
    return class EditableField extends React.Component {
        constructor() {
            super(...arguments);
            this.renderViewMode = () => {
                const { defaultValue, url } = this.props;
                if (Array.isArray(defaultValue)) {
                    if (defaultValue.length > 0) {
                        return (React.createElement(TagGroup, null, defaultValue.map(item => {
                            if (item.url && typeof item.url === "string") {
                                return (React.createElement(navigation_1.Link, { key: item.value, to: item.url },
                                    React.createElement(Tag, { text: item.label })));
                            }
                            return React.createElement(Tag, { key: item.value, text: item.label });
                        })));
                    }
                }
                else {
                    const label = (typeof defaultValue === "object" && defaultValue.label) ||
                        defaultValue;
                    const optionUrl = (typeof defaultValue === "object" && defaultValue.url) || url;
                    if (label) {
                        if (optionUrl && typeof optionUrl === "string") {
                            return (React.createElement("div", null,
                                React.createElement(navigation_1.Link, { to: optionUrl }, label)));
                        }
                        return React.createElement("div", null, label);
                    }
                }
                return (React.createElement("div", null,
                    React.createElement(styled_1.GrayText, { bold: true }, "None")));
            };
        }
        render() {
            const { message, defaultValue } = this.props;
            return (React.createElement(editable_context_1.EditableContext.Consumer, null, ({ isEditMode, isSubmitting }) => (React.createElement(form_1.Field, Object.assign({}, this.props), isEditMode
                ? ({ fieldProps, error, meta }) => (React.createElement(React.Fragment, null,
                    React.createElement(Component, Object.assign({ isDisabled: isSubmitting }, fieldProps, { meta: meta }, lodash_1.omit(this.props, "defaultValue"))),
                    message && message({ error, meta })))
                : this.renderViewMode))));
        }
    };
}
exports.withEditableField = withEditableField;
